import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function Register() {
    const { register } = useAuth();
    const navigate = useNavigate();

    const [form, setForm] = useState({ name: "", email: "", password: "" });
    const [busy, setBusy] = useState(false);
    const [err, setErr] = useState("");
    const [ok, setOk] = useState("");

    const onChange = (e) => setForm(f => ({ ...f, [e.target.name]: e.target.value }));

    const onSubmit = async (e) => {
        e.preventDefault();
        setErr(""); setOk("");
        setBusy(true);
        try {
            await register(form);
            setOk("Account created! You can sign in now.");
            // Some backends sign you in automatically; if so you could:
            navigate("/", { replace: true });
        } catch (e2) {
            setErr("Registration failed. Try a different email.");
        } finally {
            setBusy(false);
        }
    };

    return (
        <div className="w-full flex items-center justify-center p-6">
            <form onSubmit={onSubmit} className="w-full max-w-sm bg-gray-800 border border-gray-700 rounded-2xl p-6 space-y-4">
                <h1 className="text-2xl font-bold text-blue-400">Create account</h1>

                <label className="block text-sm">
                    <span className="text-gray-300">Name</span>
                    <input
                        name="name"
                        className="mt-1 w-full bg-gray-900 border border-gray-700 rounded px-3 py-2"
                        value={form.name} onChange={onChange} required
                    />
                </label>

                <label className="block text-sm">
                    <span className="text-gray-300">Email</span>
                    <input
                        type="email" name="email"
                        className="mt-1 w-full bg-gray-900 border border-gray-700 rounded px-3 py-2"
                        value={form.email} onChange={onChange} required
                    />
                </label>

                <label className="block text-sm">
                    <span className="text-gray-300">Password</span>
                    <input
                        type="password" name="password"
                        className="mt-1 w-full bg-gray-900 border border-gray-700 rounded px-3 py-2"
                        value={form.password} onChange={onChange} required
                        minLength={6}
                    />
                </label>

                {err && <div className="text-red-400 text-sm">{err}</div>}
                {ok && <div className="text-green-400 text-sm">{ok}</div>}

                <button
                    type="submit"
                    disabled={busy}
                    className={`w-full py-2 rounded-xl font-semibold ${busy ? "bg-gray-600" : "bg-blue-600 hover:bg-blue-500"}`}
                >
                    {busy ? "Creating�" : "Create account"}
                </button>

                <div className="text-sm text-gray-400">
                    Already have an account? <Link to="/login" className="text-blue-400 hover:underline">Sign in</Link>
                </div>
            </form>
        </div>
    );
}
